import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import SEO from '../../components/SEO';
import './Location.css';

const Location = () => {
  const [page, setPage] = useState(null);
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get('/pages/location');
        setPage(response.data.page || response.data);
        setSections(response.data.sections || []);
      } catch (error) {
        console.error('Failed to fetch location data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <>
      <SEO
        title={page?.title || 'Visit Us - Luxe Hair Salon'}
        description={page?.meta_description || 'Find our salon location, hours, and contact information.'}
        keywords="hair salon location, directions, hours, parking, contact"
      />
      <div className="location-page">
        <div className="location-hero">
          <div className="container">
            <h1>{page?.title || 'Visit Our Salon'}</h1>
            {page?.meta_description && <p className="hero-subtitle">{page.meta_description}</p>}
          </div>
        </div>

        <div className="container">
          <div className="location-content">
            {/* Map Placeholder */}
            <div className="location-map">
              <div className="map-placeholder">
                <div className="map-icon">📍</div>
                <p>123 Beauty Boulevard</p>
                <p>Downtown District</p>
                <p>New York, NY 10001</p>
                <a
                  href="https://www.google.com/maps"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                >
                  Open in Google Maps
                </a>
              </div>
            </div>

            {/* Location Details */}
            <div className="location-details">
              <div className="detail-card">
                <div className="detail-icon">📍</div>
                <h3>Address</h3>
                <p>123 Beauty Boulevard</p>
                <p>Downtown District</p>
                <p>New York, NY 10001</p>
              </div>

              <div className="detail-card">
                <div className="detail-icon">🕒</div>
                <h3>Hours</h3>
                <div className="hours-list">
                  <div className="hour-row">
                    <span>Monday - Friday</span>
                    <span>9:00 AM - 8:00 PM</span>
                  </div>
                  <div className="hour-row">
                    <span>Saturday</span>
                    <span>9:00 AM - 6:00 PM</span>
                  </div>
                  <div className="hour-row">
                    <span>Sunday</span>
                    <span>10:00 AM - 5:00 PM</span>
                  </div>
                </div>
              </div>

              <div className="detail-card">
                <div className="detail-icon">📞</div>
                <h3>Contact</h3>
                <p>
                  <strong>Phone:</strong>{' '}
                  <a href="tel:+15551234567">+1 (555) 123-4567</a>
                </p>
                <p>
                  <strong>Email:</strong>{' '}
                  <a href="mailto:info@luxehair.com">info@luxehair.com</a>
                </p>
              </div>

              <div className="detail-card">
                <div className="detail-icon">🚗</div>
                <h3>Parking & Transit</h3>
                <p>
                  <strong>Parking:</strong> Street parking available. Public parking
                  garage at 125 Beauty Boulevard.
                </p>
                <p>
                  <strong>Subway:</strong> Lines 1, 2, 3 to Beauty Station (2 blocks)
                </p>
                <p>
                  <strong>Bus:</strong> Routes 10, 15, 22 stop directly in front
                </p>
              </div>
            </div>

            {/* Additional Content from CMS */}
            {sections.map((section) => (
              <div key={section.id} className="location-section">
                {section.title && <h2>{section.title}</h2>}
                {section.content && (
                  <div
                    className="section-content"
                    dangerouslySetInnerHTML={{ __html: section.content.replace(/\n/g, '<br />') }}
                  />
                )}
                {section.image_url && (
                  <img
                    src={section.image_url}
                    alt={section.title || 'Location'}
                    className="section-image"
                  />
                )}
              </div>
            ))}

            {/* CTA Section */}
            <div className="location-cta">
              <h2>Ready to Visit?</h2>
              <p>Book your appointment today and experience luxury hair care.</p>
              <a href="/contact" className="btn btn-primary btn-large">
                Book Appointment
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Location;
